module.exports = __webpack_public_path__ + "static/cinemax2-c142276889af986bb441b7cfad4f7de3.png";